export const SHOW_AWARD = 'SHOW_AWARD';
export const HIDE_AWARD = 'HIDE_AWARD';
export const SET_CURRENT_CARD = 'SET_CURRENT_CARD';
